import React from "react";
import {
  Factory,
  Landmark,
  Anchor,
  Wind,
  Plane,
  Droplets,
} from "lucide-react";

const IndustryVerticals = () => {
  const industries = [
    {
      name: "Oil & Gas",
      icon: <Droplets />,
      desc:
        "Pipeline, refinery, and pressure vessel inspection using PAUT, TOFD, UT, MT, and PT to ensure asset integrity and safety compliance.",
    },
    {
      name: "Renewable Energy",
      icon: <Wind />,
      desc:
        "Wind turbine, solar structure, and energy plant inspection including blade testing, weld inspection, and structural monitoring.",
    },
    {
      name: "Maritime & Shipyard",
      icon: <Anchor />,
      desc:
        "Hull inspection, tank testing, welding inspection, and classification support for shipyard and offshore structures.",
    },
    {
      name: "Aerospace",
      icon: <Plane />,
      desc:
        "Composite material testing, crack detection, and high precision NDT for aviation and aerospace components.",
    },
    {
      name: "Infrastructure",
      icon: <Landmark />,
      desc:
        "Bridge, tunnel, building, and structural inspection using ultrasonic testing and advanced scanning methods.",
    },
    {
      name: "Manufacturing",
      icon: <Factory />,
      desc:
        "Production line inspection, component testing, weld quality verification, and automated NDT solutions.",
    },
  ];

  return (
    <section
      id="industries"
      className="py-20 md:py-32 px-4 sm:px-6 bg-slate-950 text-white"
    >
      <div className="max-w-6xl mx-auto">

        {/* HEADER */}

        <div className="mb-16 md:mb-20">

          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-[2px] bg-orange-600" />
            <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">
              Industries We Serve
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-6xl font-black">
            Industrial Inspection & NDT Services
          </h2>

          <p className="text-slate-400 mt-4 max-w-2xl text-sm leading-relaxed">
            Focus NDT Group provides advanced non-destructive testing,
            inspection services, and asset integrity solutions for oil & gas,
            shipyard, power, infrastructure, manufacturing, and renewable
            energy industries. Our team delivers PAUT, TOFD, ultrasonic testing,
            and custom inspection solutions to ensure safety, compliance,
            and long-term reliability of critical equipment.
          </p>

        </div>



        {/* GRID */}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">

          {industries.map((ind, i) => (

            <div
              key={i}
              className="group border border-white/10 bg-slate-900 p-6 hover:bg-orange-600 transition"
            >

              <div className="mb-4 text-orange-500 group-hover:text-white">
                {React.cloneElement(ind.icon, { size: 34 })}
              </div>

              <h3 className="font-bold text-lg">
                {ind.name}
              </h3>

              <p className="text-sm text-slate-400 mt-2 group-hover:text-white">
                {ind.desc}
              </p>

            </div>

          ))}

        </div>



        {/* SEO TEXT */}

        <div className="mt-16 max-w-3xl text-sm text-slate-500 leading-relaxed">

          <p>
            Our inspection and non destructive testing services support
            industries worldwide with reliable NDT solutions including PAUT,
            TOFD, ultrasonic testing, magnetic particle testing, dye penetrant
            testing, and visual inspection. We specialize in shutdown projects,
            offshore inspection, pipeline testing, structural inspection,
            and industrial asset integrity programs.
          </p>

        </div>



        {/* CTA */}

      <div className="mt-10">

  <p className="text-sm text-slate-400">

    Need inspection services for your project?

    <a
      href="#contact"
      className="text-orange-500 font-bold ml-2"
    >
      Contact Focus NDT Group &nbsp;
    </a>

    for specialized NDT solutions.

  </p>

</div>
      </div>
    </section>
  );
};

export default IndustryVerticals;